import { functions } from 'helpers/functions';
import { combineReducers } from 'redux';

const quickView = (state = false, action: any) => {
  switch (action.type) {
    case 'MY_SALES/OPEN_QUICK_VIEW':
      return true;
    case 'MY_SALES/CLOSE_QUICK_VIEW':
      return false;
    default:
      return state;
  }
};

const filters = (state: any = null, action: any) => {
  switch (action.type) {
    case 'MY_SALES/SET_FILTERS':
      return functions.cloneDeep(action.filters);
    case 'MY_SALES/GET_FILTERS':
      return state;
    default:
      return state;
  }
};

const pagination = (state: any = null, action: any) => {
  switch (action.type) {
    case 'MY_SALES/SET_PAGINATION':
      return functions.cloneDeep(action.pagination);
    case 'MY_SALES/GET_PAGINATION':
      return state;
    default:
      return state;
  }
};

const currentInvoice = (state: any = null, action: any) => {
  switch (action.type) {
    case 'MY_SALES/SET_CURRENT_INVOICE':
      return action.invoice;
    case 'MY_SALES/RESET_CURRENT_INVOICE':
      return null;
    default:
      return state;
  }
};

const filterIsOpen = (state = false, action: any) => {
  switch (action.type) {
    case 'MY_SALES/OPEN_FILTER':
      return true;
    case 'MY_SALES/CLOSE_FILTER':
      return false;
    default:
      return state;
  }
};

const currentTab = (state: 'all' | 'confirmed' | 'boleto' | 'refunded' | 'recovering' | 'funil' = 'all', action: any) => {
  switch (action.type) {
    case 'MY_SALES/CHANGE_CURRENT_TAB':
      return action.tab;
    default:
      return state;
  }
};

export const mySalesReducer = combineReducers({
  quickView,
  currentInvoice,
  filters,
  pagination,
  filterIsOpen,
  currentTab,
});
